<div id="myModal" class="modal fade" tabindex="-1" role="dialog">
  <div class="modal-dialog modal-lg">
    <div class="modal-content">
      <div class="modal-header" style="padding:5px 18px; background-color:#63a356;">
        <legend style="color:#fff;font-size:14px;margin:0;">Filters</legend>
        <button type="button" class="btn btn-sm btn-danger pull-right c" (click)="closeModal()">&times;</button>
      </div>
      <div class="modal-body" #container>
        <form *ngIf="form" [formGroup]="form" (ngSubmit)="refreshData()">

          <kendo-tabstrip #tabStrip [keepTabContent]="true" class="dashboard-filter" (tabSelect)="onTabSelect($event)">

            <kendo-tabstrip-tab title="Location" [selected]="true">
              <ng-template kendoTabContent>
                <div style="padding: 2px 25px;">

                  <div class="row">
                    <legend class="k-form-legend">Areas</legend>
                    <kendo-multiselect id="areas" formControlName="areas"
                        [data]="areas" [textField]="'area'" [valueField]="'id'"
                        (valueChange)="handleAreasSelectionChange($event)">
                    </kendo-multiselect>
                  </div>

                  <div class="row">
                    <legend class="k-form-legend">Countries</legend>
                    <kendo-multiselect id="countries" formControlName="countries"
                        [data]="areaFilteredCountries" [textField]="'country'" [valueField]="'countryCode'"
                        (valueChange)="handleCountriesChange($event)">
                    </kendo-multiselect>

                  </div>

                  <div class="row">
                    <legend class="k-form-legend">Local Levels</legend>
                    <kendo-multiselect id="localLevels" formControlName="localLevels"
                        [data]="filteredLocalLevels" [textField]="'localLevel'" [valueField]="'localLevel'">
                    </kendo-multiselect>
                  </div>

                </div>
              </ng-template>
            </kendo-tabstrip-tab>


            <kendo-tabstrip-tab title="Customer">
              <ng-template kendoTabContent>
                <div style="padding: 2px 25px;">
                  <div class="row">
                    <legend class="k-form-legend">Customers</legend>
                    <kendo-multiselect #customersMultiSelect id="customers"
                        formControlName="customers"
                        [data]="customers"
                        [placeholder]="'Please type at least 4 characters to begin search'"
                        [valueField]="'customerNum'"  [textField]="'customerDisplayString'"
                        [filterable]="true" (filterChange)="handleCustomersFilter($event)">
                    </kendo-multiselect>
                  </div>
                </div>
              </ng-template>
            </kendo-tabstrip-tab>

            <kendo-tabstrip-tab title="Product">
              <ng-template kendoTabContent>
                <div style="padding: 2px 25px;">
                  <div class="row">
                    <legend class="k-form-legend">Product Line</legend>
                    <kendo-combobox id="productLine" formControlName="productLine"
                        [data]="productLines"
                        [valueField]="'id'" [textField]="'prodFamilyPLDisplayName'"
                        (valueChange)="handleProductLineChange($event)">
                    </kendo-combobox>
                  </div>

                  <div class="row">
                    <legend class="k-form-legend">Serial Numbers</legend>
                    <kendo-multiselect #serialNumbersMultiSelect id="serialNumbers"
                        formControlName="serialNumbers"
                        [data]="serialNumbers"
                        [placeholder]="'Please type at least 3 characters to begin search'"
                        [valueField]="'sn'"  [textField]="'sn'"
                        [filterable]="true" (filterChange)="handleSerialNumbersFilter($event)">
                    </kendo-multiselect>
                  </div>
                </div>
              </ng-template>
            </kendo-tabstrip-tab>


            <kendo-tabstrip-tab title="Algorithm">
              <ng-template kendoTabContent>
                <div style="padding: 2px 25px;">

                  <div class="row">
                    <legend class="k-form-legend">Algorithms</legend>
                    <kendo-multiselect id="algorithms" formControlName="algorithms"
                      [data]="algorithms" [textField]="'algorithmName'" [valueField]="'algorithmId'"
                      (valueChange)="handleAlgorithmsChange($event)">
                    </kendo-multiselect>
                  </div>

                  <div class="row">
                    <legend class="k-form-legend">Algorithm Indicator</legend>
                    <kendo-multiselect id="algorithmIndicators" formControlName="algorithmIndicators"
                        [data]="filteredAlgorithmIndicators"
                        [textField]="'algIndicatorName'" [valueField]="'algIndicatorId'">
                    </kendo-multiselect>
                  </div>

                </div>
              </ng-template>
            </kendo-tabstrip-tab>

            <kendo-tabstrip-tab title="Suppression">
              <ng-template kendoTabContent>
                <div style="padding: 2px 25px;">

                  <div class="row">
                    <legend class="k-form-legend">Suppression</legend>
                    <kendo-multiselect [data]="suppression" formControlName="suppression"
                        [textField]="'suppression'" [valueField]="'suppression'" [valuePrimitive]="true">
                    </kendo-multiselect>
                  </div>
                  <!-- Added note below the dropdown -->
                  <p style="margin-top: 10px; color: red;">Note: Instruments that failed any of the selected suppression checks</p>
                </div>
              </ng-template>
            </kendo-tabstrip-tab>

            <kendo-tabstrip-tab title="Notifications">
              <ng-template kendoTabContent>
                <div style="padding: 2px 25px;">

                  <div class="row">
                    <legend class="k-form-legend">Ticket Type</legend>
                    <kendo-multiselect [data]="ticketType" formControlName="ticketType"
                                       [textField]="'ticketType'" [valueField]="'ticketType'" [valuePrimitive]="true">
                    </kendo-multiselect>
                  </div>

                  <div class="row">
                    <legend class="k-form-legend">Notifications</legend>
                    <kendo-multiselect [data]="notification" formControlName="notification"
                                       [textField]="'notification'" [valueField]="'notification'" [valuePrimitive]="true">
                    </kendo-multiselect>
                  </div>
                  <!-- Added note below the dropdown -->
                  <p style="margin-top: 10px; color: red;">Note: Instruments that met any of the selected notification options</p>
                </div>
              </ng-template>
            </kendo-tabstrip-tab>

            <kendo-tabstrip-tab title="Date Range">
              <ng-template kendoTabContent>
                <kendo-daterange>
                  <div style="padding: 2px 25px;">

                    <div class="row">
                      <legend>Start Date <span style="color: #f00;">*</span></legend>

                      <kendo-datepicker class="customClass" formControlName="startDate"
                          [min]="minDate" [max]="form.get('endDate').value"
                          [format]="'yyyy-MM-dd'"
                          [ngModel]="startDate"
                          [popupSettings]="{ appendTo: containerRef }"
                       ></kendo-datepicker>
                    </div>
                    <div class="row">
                      <em *ngIf="form.get('startDate').invalid">
                          Invalid Start Date
                      </em>
                    </div>
                    <div class="row">
                      <legend>End Date <span style="color: #f00;">*</span></legend>
                      <kendo-datepicker formControlName="endDate" class="customClass"
                        [ngModel]="endDate"  [min]="form.get('startDate').value"
                        [format]="'yyyy-MM-dd '"
                        [popupSettings]="{ appendTo: containerRef }"
                      ></kendo-datepicker>
                    </div>
                    <div class="row">
                      <em *ngIf="form.get('endDate').invalid">
                          Invalid End Date
                      </em>
                  </div>
                  </div>
                </kendo-daterange>
              </ng-template>
            </kendo-tabstrip-tab>
          </kendo-tabstrip>
          <div class="modal-footer d-flex justify-content-around">
            <button type="button" class="btn btn-default col-5 small-side-padding" (click)="resetFilters()">Reset Filters</button>
            <button type="button" class="btn btn-primary col-5 small-side-padding" style="height:auto;" [disabled]="form?.invalid"
                (click)="refreshData(); closeEvent.emit()">Apply Filters</button>
          </div>
        </form>
      </div>

      <!-- <div class="modal-footer d-flex justify-content-around">
        <a class='btn btn-default col-5 small-side-padding' (click)="resetFilters()" style="height:auto;">Reset Filters</a>
        <button class="btn btn-primary col-5 small-side-padding" (click)="onSubmit(form)"
            style="height:auto;" type="submit">Apply Filters</button>
      </div> -->

    </div>
  </div>
</div>



<div class='card-body'>
  <div class="row" style="margin-top: 5px;">

    <div *ngIf="displayAreas.length > 0 || displayCountries.length > 0" class="col-lg-2 col-md-4 col-sm-6 col-xs-12">
      <label class="control-label mb-2">Area:</label>
      <ul style="max-height: 150px; overflow-y: auto;">
          <li *ngFor="let area of displayAreas">
              {{area}}
          </li>
      </ul>
      <label class="control-label mb-2">Countries:</label>
      <ul style="max-height: 150px; overflow-y: auto;">
          <li *ngFor="let country of displayCountries">
              {{country}}
          </li>
      </ul>
    </div>

    <div *ngIf="displayAreas.length == 0 && displayCountries.length == 0" class="col-lg-2 col-md-4 col-sm-6 col-xs-12">
      <label class="control-label">Area:</label> WorldWide
      <ul style="max-height: 150px; overflow-y: auto;"></ul>
      <label class="control-label">Countries:</label> WorldWide
      <ul style="max-height: 150px; overflow-y: auto;"></ul>
    </div>

    <div class="col-md-2">
      <label class="control-label mb-2">Local Levels:</label>
      <!-- {{displayLocalLevel1}} -->
      <ul style="max-height: 150px; overflow-y: auto;">
        <li *ngFor="let localLevel of displayLocalLevels">
            {{localLevel}}
        </li>
      </ul>
      <!-- <br/> -->
      <label class="control-label mb-2">Customers: </label>
      <ul style="max-height: 150px; overflow-y: auto;">
        <li *ngFor="let displayCustomer of displayCustomers">
            {{displayCustomer}}
        </li>
      </ul>
    </div>

    <div class="col-md-2">
      <label class="control-label mb-2"> Product Line:</label>
      <ul style="max-height: 150px; overflow-y: auto;">
        <li *ngIf="displayProductLine">
            {{displayProductLine}}
        </li>
      </ul>

      <label class="control-label mb-2">Serial Numbers:</label>
      <ul style="max-height: 150px; overflow-y: auto;">
        <li *ngFor="let displaySerialNumber of displaySerialNumbers">
            {{displaySerialNumber}}
        </li>
      </ul>

    </div>

    <div class="col-md-2">
      <label class="control-label mb-2">Algorithm:</label>
      <ul style="max-height: 150px; overflow-y: auto;">
        <li *ngFor="let algorithm of displayAlgorithms">
            {{algorithm}}
        </li>
      </ul>
      <!-- <br /> -->
      <label class="control-label mb-2">Algorithm Indicator:</label>
      <!-- <span id="valueAlgorithmIndicator"></span> -->
      <ul style="max-height: 150px; overflow-y: auto;">
        <li *ngFor="let algIndicator of displayAlgorithmIndicators">
            {{algIndicator}}
        </li>
      </ul>
    </div>

    <div class="col-md-2">
      <label class="control-label mb-2">Suppression:</label>
      <ul style="max-height: 150px; overflow-y: auto;">
        <li *ngFor="let suppression of displaySuppression">
          {{suppression}}
        </li>
      </ul>

      <label class="control-label mb-2">Ticket Type:</label>
      <!-- <span id="valueAlgorithmIndicator"></span> -->
      <ul style="max-height: 150px; overflow-y: auto;">
        <li *ngFor="let ticketType of displayTicketType">
          {{ticketType}}
        </li>
      </ul>
      <!-- <br /> -->
      <label class="control-label mb-2">Notifications:</label>
      <!-- <span id="valueAlgorithmIndicator"></span> -->
      <ul style="max-height: 150px; overflow-y: auto;">
        <li *ngFor="let notifications of displayNotifications">
          {{notifications}}
        </li>
      </ul>
    </div>

    <div class="col-md-2">
      <label class="control-label mb-2">Start Date:</label> {{startDate | date : fullFormat }}
      <ul style="max-height: 150px; overflow-y: auto;"></ul>
      <label class="control-label mb-2">End Date: </label> {{endDate | date : fullFormat}}
      <ul style="max-height: 150px; overflow-y: auto;"></ul>
    </div>


  </div>

</div>

<div class='card card-primary'>
  <div class='card-header'>
    <div class="row">
      <div class="col-sm-6">Notification Summary and Chart Data</div>
      <div class="col-sm-6">
          <span style='float: right! important; font-size: 18px;' class="fas" [ngClass]="{'fa-angle-down': minimizeNtfnSummary, 'fa-angle-up': !minimizeNtfnSummary }"
                (click)="minimizeNtfnSummary = !minimizeNtfnSummary"></span>
      </div>
    </div>
  </div>
</div>

<div class='card-body notification-counts-card' *ngIf="!minimizeNtfnSummary">
  <div class="row" style="margin-top: 5px;">
    <div class="col-sm-5">
      <kendo-chart>
        <kendo-chart-title text="Algorithm Indicator Flagged Counts">
        </kendo-chart-title>
        <kendo-chart-tooltip [shared]="true" background="#aa0061" color="white" [padding]=2>
          <ng-template
            kendoChartSharedTooltipTemplate
            let-category="category"
            let-points="points"
          >
            <!-- <div>{{ category }}</div> -->
            <div *ngFor="let point of points">
              {{ point.dataItem.algorithmName }}: {{ point.dataItem.algIndicatorName }} - {{ point.value }}
            </div>
          </ng-template>
        </kendo-chart-tooltip>
        <kendo-chart-series>
          <!-- <kendo-chart-series-item type="bar" color="blue" field="flaggedCount"
              categoryField="algorithmName" [data]="flaggedChartData | async">
            <kendo-chart-series-item-labels format="{0:N}"></kendo-chart-series-item-labels>
          </kendo-chart-series-item> -->
          <kendo-chart-series-item type="bar" color="blue" field="flaggedCount"
              categoryField="algNameIndicatorName" [data]="flaggedChartData | async">
            <kendo-chart-series-item-labels format="{0}"></kendo-chart-series-item-labels>
            <!-- <kendo-chart-series-item-labels [content]="showCategory"></kendo-chart-series-item-labels> -->
            <!-- <kendo-chart-series-item-tooltip background="#aa0061" [padding]=2>
              <ng-template let-value="value" let-category="category">
                  {{category}} - {{value}}
              </ng-template>
            </kendo-chart-series-item-tooltip> -->
          </kendo-chart-series-item>
        </kendo-chart-series>
        <!-- <kendo-chart-legend position="bottom" orientation="horizontal"></kendo-chart-legend> -->
        <kendo-chart-category-axis>
          <kendo-chart-category-axis-item>
            <kendo-chart-value-axis-item-labels [content]="categoryDisplayVal">
            </kendo-chart-value-axis-item-labels>
          </kendo-chart-category-axis-item>
        </kendo-chart-category-axis>
      </kendo-chart>
    </div>

    <div class="col-sm-2">
      <div class="row" style="
        border: 1px solid #e2e2e2;
        margin-top: 5px;
        padding: 11px 0px;
        border-radius: 8px;">
        <h6 style=" font-weight: 200;">Distinct SNs with Flags</h6>
        <hr/>
        <h1 style=" text-shadow: 2px 2px #e2e2e2;">{{flaggedCount}}</h1>
      </div>

      <div class="row" style="
        border: 1px solid #e2e2e2;
        margin-top: 5px;
        padding: 11px 0px;
        border-radius: 8px;">
        <h6 style=" font-weight: 200;">Suppressed, Distinct SNs</h6>
        <hr/>
        <h1 style=" text-shadow: 2px 2px #e2e2e2;">{{suppressedCount}}</h1>
      </div>

      <div class="row" style="
        border: 1px solid #e2e2e2;
        margin-top: 5px;
        padding: 11px 0px;
        border-radius: 8px;">
        <h6 style="font-weight: 200">Ticket Notifications, Distinct SNs</h6>
        <hr/>
        <h1 style=" text-shadow: 2px 2px #e2e2e2;">{{notificationCount}}</h1>
      </div>
    </div>
    <div class="col-sm-5">
      <!-- <kendo-chart [transitions]="false">
        <kendo-chart-series>
          <kendo-chart-series-item type="bar" color="green" field="value" categoryField="key" [data]="chartCategories">
          </kendo-chart-series-item>
        </kendo-chart-series>
      </kendo-chart> -->
      <!-- <kendo-chart>
        <kendo-chart-title text="SN counts by Algorithm">
        </kendo-chart-title>
        <kendo-chart-series>
          <kendo-chart-series-item type="bar" [stack]="true" field="value.algorithm" categoryField="key" [data]="chartCategories">
            <kendo-chart-series-item-labels format="{0:N}"></kendo-chart-series-item-labels>
          </kendo-chart-series-item>
        </kendo-chart-series>
        <kendo-chart-legend position="bottom" orientation="horizontal"></kendo-chart-legend>
      </kendo-chart>       -->
      <div *ngIf="chartOptions !== null && chartOptions != undefined">
        <kendo-chart
            [seriesDefaults]="chartOptions.seriesDefaults"
            [series]="chartOptions.series"
            [valueAxis]="chartOptions.valueAxis"
            [categoryAxis]="chartOptions.categoryAxis"
            [plotArea]="chartOptions.chartArea">
        </kendo-chart>
      </div>
    </div>
  </div>
</div>
<div style="margin: 5px;"></div>
<div class='card card-primary'>
  <div class='card-header'>
    <div class="row">
      <div class="col-sm-6">
        Notification Data
      </div>
      <div class="col-sm-6">
        <span style='float: right! important; font-size: 18px;' class="fas" [ngClass]="{'fa-angle-down': minimizeNtfnData, 'fa-angle-up': !minimizeNtfnData }"
              (click)="minimizeNtfnData = !minimizeNtfnData"></span>
    </div>
    </div>
  </div>
</div>

<div class='card-body' *ngIf="!minimizeNtfnData">
  <kendo-grid #grid id="grid" [pageSize]="state.take" [skip]="state.skip" [sort]="state.sort" [filter]="stateFilter"
    [sortable]="gridSettings.sortable" [pageable]="gridSettings.pageable" [selectable]="true" [filterable]="!gridSettings.dashboardMode"
    [resizable]="true"
    [ngStyle]="{'max-height': getMaxHeight()}" [height]="getHeight()" [kendoGridBinding]="(gridData | async)" (filterChange)="onFilterChange($event)">

    <!--Kendo Toolbar-->
    <ng-template kendoGridToolbarTemplate>
      <div class="row" >
          <div class="col-sm-6">
              <div class="columns columns-right btn-group">
                  <div class="keep-open btn-group" [ngClass]="{'open': isFieldsOpen}" click-outside (clickOutside)="onClickOutside(0, $event)">
                    <button class="btn btn-default dropdown-toggle" type="button" (click)="isFieldsOpen = !isFieldsOpen">
                      <i class="fa fa-th"></i> Fields <span class="caret"></span>
                    </button>
                    <ul class="dropdown-menu scrollable-menu fields" role="menu">
                      <li (click)="toggleAllColumnsVisibility()">
                        <a class="small"><input type="checkbox" [(ngModel)]="allColumnsVisible"> Select All</a>
                      </li>
                      <hr style="margin: -2px 0 10px 0;">
                      <li *ngFor="let column of gridSettings?.columnSettings" (click)="hideColumn(column.field)">
                        <a class="small">
                          <input id="{{column.field}}" type="checkbox" [checked]="hiddenColumns.indexOf(column.field) === -1">
                          {{column.title}}
                        </a>
                      </li>
                    </ul>
                  </div>
                  <div class="export btn-group" [ngClass]="{'open': isExportOpen}" click-outside (clickOutside)="onClickOutside(1, $event)">
                      <button class="btn btn-default dropdown-toggle" type="button" (click)="isExportOpen = !isExportOpen" >
                          <i class="fa fa-share-square"></i> Export <span class="caret"></span>
                      </button>
                      <ul class="dropdown-menu export-menu" role="menu" (click)="closeAllMenus()" >
                          <li data-type="json">
                              <a class="k-button small" (click)="saveJson()"><span>JSON</span></a>
                          </li>
                          <li>
                              <a class="small" kendoGridExcelCommand><span>Excel</span></a>
                          </li>
                      </ul>
                  </div>
                  <div class="btn-group">
                      <button class="btn btn-default" type="button" (click)="refreshData()" >
                          <i class="fa fa-sync-alt"></i> Refresh
                      </button>
                  </div>
              </div>
              <div class="export btn-group">
                <button class="btn btn-default" (click)="downloadExcel()">
                  <i class="fa fa-share-square"></i> Export All
                </button>
                <span style="margin-left: 10px; margin-top: 2px; display: inline-block;">
                  Showing 1-{{notificationDataSize}} of total {{totalCountAvailable}} records
                </span>
              </div>
          </div>
          <div class="col-sm-6">
            <div style="float: right">
              <label class="control-label" for="autoRefreshMode">Auto Refresh:&nbsp;</label>
              <kendo-switch id="autoRefreshMode" [(ngModel)]="autoRefreshMode" [onLabel]="'On'" [offLabel]="'Off'" (valueChange)="updateAutoRefreshMode($event)"></kendo-switch>
            </div>
          </div>
      </div>
    </ng-template>
    <!--End Kendo Toolbar-->

    <kendo-grid-column *ngIf="hiddenColumns.indexOf('sn') === -1" [field]="'sn'" title="SN" [width]="100" [style]="{'text-align': 'left' }"
      [sortable]="true" [filterable]="true" [filter]="'text'">
      <ng-template kendoGridFilterCellTemplate let-filter>
        <dashboard-grid-text-filter [filter]="filter" placeholder="" [filterOperator]="'contains'" [field]="'sn'">
        </dashboard-grid-text-filter>
      </ng-template>
    </kendo-grid-column>
    <kendo-grid-column *ngIf="hiddenColumns.indexOf('productLine') === -1" [field]="'productLine'" title="Product Line" [width]="100" [style]="{'text-align': 'left' }"
      [sortable]="true" [filterable]="true" [filter]="'text'">
      <ng-template kendoGridFilterCellTemplate let-filter>
        <dashboard-grid-text-filter [filter]="filter" placeholder="" [filterOperator]="'contains'" [field]="'productLine'">
        </dashboard-grid-text-filter>
      </ng-template>
    </kendo-grid-column>
    <kendo-grid-column *ngIf="hiddenColumns.indexOf('jobRunDate') === -1" [field]="'jobRunDate'" title="Job Run Date" [width]="100" [style]="{'text-align': 'left' }"
          [sortable]="true" [filterable]="true" [filter]="'text'">
      <ng-template kendoGridFilterCellTemplate let-filter>
        <dashboard-grid-text-filter [filter]="filter" placeholder="" [filterOperator]="'contains'" [field]="'jobRunDate'">
        </dashboard-grid-text-filter>
      </ng-template>
<!--      <ng-template kendoGridFilterCellTemplate let-filter let-column="column">-->
<!--        <kendo-grid-date-filter-cell-->
<!--          [showOperators]="true"-->
<!--          [column]="column"-->
<!--          [filter]="filter"-->
<!--          format="yyyy-MM-dd"-->
<!--          [placeholder]="'Select Date'">-->
<!--            <kendo-filter-eq-operator [text]="' =='"></kendo-filter-eq-operator>-->
<!--            <kendo-filter-neq-operator [text]="' !='"></kendo-filter-neq-operator>-->
<!--            <kendo-filter-gte-operator [text]="' >='"></kendo-filter-gte-operator>-->
<!--            <kendo-filter-after-operator [text]="' >'"></kendo-filter-after-operator>-->
<!--            <kendo-filter-lte-operator [text]="' <='"></kendo-filter-lte-operator>-->
<!--            <kendo-filter-before-operator [text]="' <'"></kendo-filter-before-operator>-->
<!--            <kendo-filter-isnull-operator [text]="' Empty'"></kendo-filter-isnull-operator>-->
<!--            <kendo-filter-isnotnull-operator [text]="' Non Empty'"></kendo-filter-isnotnull-operator>-->
<!--        </kendo-grid-date-filter-cell>-->
<!--      </ng-template>-->
    </kendo-grid-column>
    <kendo-grid-column *ngIf="hiddenColumns.indexOf('notificationProcessedDate') === -1" [field]="'notificationProcessedDate'" title="Notification Processed Date" [width]="180" [style]="{'text-align': 'left' }"
          [sortable]="true" [filterable]="true" [filter]="'date'" >
          <ng-template kendoGridCellTemplate let-dataItem>
            {{ convertToUserTimeZone(dataItem.notificationProcessedDate) | date:'yyyy-MM-dd HH:mm' }}
          </ng-template>
      <ng-template kendoGridFilterCellTemplate let-filter let-column="column">
        <kendo-grid-date-filter-cell
          [showOperators]="true"
          [column]="column"
          [filter]="filter"
          format="yyyy-MM-dd HH:mm"
          [placeholder]="'Select Date'" >
            <kendo-filter-eq-operator [text]="' =='"></kendo-filter-eq-operator>
            <kendo-filter-neq-operator [text]="' !='"></kendo-filter-neq-operator>
            <kendo-filter-gte-operator [text]="' >='"></kendo-filter-gte-operator>
            <kendo-filter-after-operator [text]="' >'"></kendo-filter-after-operator>
            <kendo-filter-lte-operator [text]="' <='"></kendo-filter-lte-operator>
            <kendo-filter-before-operator [text]="' <'"></kendo-filter-before-operator>
            <kendo-filter-isnull-operator [text]="' Empty'"></kendo-filter-isnull-operator>
            <kendo-filter-isnotnull-operator [text]="' Non Empty'"></kendo-filter-isnotnull-operator>
        </kendo-grid-date-filter-cell>
      </ng-template>
    </kendo-grid-column>
    <kendo-grid-column *ngIf="hiddenColumns.indexOf('flaggedDate') === -1" [field]="'flaggedDate'" title="Flagged Date" [width]="180" [style]="{'text-align': 'left' }"
                       [sortable]="true" [filterable]="true" [filter]="'date'" [format]="'{0:yyyy-MM-dd HH:mm}'">
      <ng-template kendoGridFilterCellTemplate let-filter let-column="column">
        <kendo-grid-date-filter-cell
          [showOperators]="true"
          [column]="column"
          [filter]="filter"
          format="yyyy-MM-dd HH:mm"
          [placeholder]="'Select Date'">
          <kendo-filter-eq-operator [text]="' =='"></kendo-filter-eq-operator>
          <kendo-filter-neq-operator [text]="' !='"></kendo-filter-neq-operator>
          <kendo-filter-gte-operator [text]="' >='"></kendo-filter-gte-operator>
          <kendo-filter-after-operator [text]="' >'"></kendo-filter-after-operator>
          <kendo-filter-lte-operator [text]="' <='"></kendo-filter-lte-operator>
          <kendo-filter-before-operator [text]="' <'"></kendo-filter-before-operator>
          <kendo-filter-isnull-operator [text]="' Empty'"></kendo-filter-isnull-operator>
          <kendo-filter-isnotnull-operator [text]="' Non Empty'"></kendo-filter-isnotnull-operator>
        </kendo-grid-date-filter-cell>
      </ng-template>
    </kendo-grid-column>
    <kendo-grid-column *ngIf="hiddenColumns.indexOf('customerName') === -1" [field]="'customerName'" title="Customer Name" [width]="150" [style]="{'text-align': 'left' }"
      [sortable]="true" [filterable]="true" [filter]="'text'">
      <ng-template kendoGridFilterCellTemplate let-filter>
        <dashboard-grid-text-filter [filter]="filter" placeholder="" [filterOperator]="'contains'" [field]="'customerName'">
        </dashboard-grid-text-filter>
      </ng-template>
    </kendo-grid-column>
    <kendo-grid-column *ngIf="hiddenColumns.indexOf('customerNumber') === -1" [field]="'customerNumber'" title="Customer Number" [width]="150" [style]="{'text-align': 'left' }"
      [sortable]="true" [filterable]="true" [filter]="'text'">
      <ng-template kendoGridFilterCellTemplate let-filter>
        <dashboard-grid-text-filter [filter]="filter" placeholder="" [filterOperator]="'contains'" [field]="'customerNumber'">
        </dashboard-grid-text-filter>
      </ng-template>
    </kendo-grid-column>
    <kendo-grid-column *ngIf="hiddenColumns.indexOf('area') === -1" [field]="'area'" title="Area" [width]="100" [style]="{'text-align': 'left' }"
      [sortable]="true" [filterable]="true" [filter]="'text'">
      <ng-template kendoGridFilterCellTemplate let-filter>
        <dashboard-grid-text-filter [filter]="filter" placeholder="" [filterOperator]="'contains'" [field]="'area'">
        </dashboard-grid-text-filter>
      </ng-template>
    </kendo-grid-column>
    <kendo-grid-column *ngIf="hiddenColumns.indexOf('country') === -1" [field]="'country'" title="Country" [width]="100" [style]="{'text-align': 'left' }"
      [sortable]="true" [filterable]="true" [filter]="'text'">
      <ng-template kendoGridFilterCellTemplate let-filter>
        <dashboard-grid-text-filter [filter]="filter" placeholder="" [filterOperator]="'contains'" [field]="'country'">
        </dashboard-grid-text-filter>
      </ng-template>
    </kendo-grid-column>
    <kendo-grid-column *ngIf="hiddenColumns.indexOf('localLevel1') === -1" [field]="'localLevel1'" title="Local Level1" [width]="100" [style]="{'text-align': 'left' }"
      [sortable]="true" [filterable]="true" [filter]="'text'">
      <ng-template kendoGridFilterCellTemplate let-filter>
        <dashboard-grid-text-filter [filter]="filter" placeholder="" [filterOperator]="'contains'" [field]="'localLevel1'">
        </dashboard-grid-text-filter>
      </ng-template>
    </kendo-grid-column>
    <kendo-grid-column *ngIf="hiddenColumns.indexOf('localLevel2') === -1" [field]="'localLevel2'" title="Local Level2" [width]="100" [style]="{'text-align': 'left' }"
      [sortable]="true" [filterable]="true" [filter]="'text'">
      <ng-template kendoGridFilterCellTemplate let-filter>
        <dashboard-grid-text-filter [filter]="filter" placeholder="" [filterOperator]="'contains'" [field]="'localLevel2'">
        </dashboard-grid-text-filter>
      </ng-template>
    </kendo-grid-column>
    <kendo-grid-column *ngIf="hiddenColumns.indexOf('primaryFSR') === -1" [field]="'primaryFSR'" title="Primary FSR" [width]="100" [style]="{'text-align': 'left' }"
      [sortable]="true" [filterable]="true" [filter]="'text'">
      <ng-template kendoGridFilterCellTemplate let-filter>
        <dashboard-grid-text-filter [filter]="filter" placeholder="" [filterOperator]="'contains'" [field]="'primaryFSR'">
        </dashboard-grid-text-filter>
      </ng-template>
    </kendo-grid-column>
    <kendo-grid-column *ngIf="hiddenColumns.indexOf('algorithm') === -1" [field]="'algorithm'" title="Algorithm" [width]="120" [style]="{'text-align': 'left' }"
      [sortable]="true" [filterable]="true" [filter]="'text'">
      <ng-template kendoGridFilterCellTemplate let-filter>
        <dashboard-grid-text-filter [filter]="filter" placeholder="" [filterOperator]="'contains'" [field]="'algorithm'">
        </dashboard-grid-text-filter>
      </ng-template>
    </kendo-grid-column>
    <kendo-grid-column *ngIf="hiddenColumns.indexOf('algorithmIndicator') === -1" [field]="'algorithmIndicator'" title="Algorithm Indicator" [width]="150" [style]="{'text-align': 'left' }"
      [sortable]="true" [filterable]="true" [filter]="'text'">
      <ng-template kendoGridFilterCellTemplate let-filter>
        <dashboard-grid-text-filter [filter]="filter" placeholder="" [filterOperator]="'contains'" [field]="'algorithmIndicator'">
        </dashboard-grid-text-filter>
      </ng-template>
    </kendo-grid-column>
    <kendo-grid-column *ngIf="hiddenColumns.indexOf('experienceCode') === -1" [field]="'experienceCode'" title="Experience Code" [width]="100" [style]="{'text-align': 'left' }"
      [sortable]="true" [filterable]="true" [filter]="'text'">
      <ng-template kendoGridFilterCellTemplate let-filter>
        <dashboard-grid-text-filter [filter]="filter" placeholder="" [filterOperator]="'contains'" [field]="'experienceCode'">
        </dashboard-grid-text-filter>
      </ng-template>
    </kendo-grid-column>
    <kendo-grid-column *ngIf="hiddenColumns.indexOf('experienceCodeDesc') === -1" [field]="'experienceCodeDesc'" title="Experience Code Desc" [width]="100" [style]="{'text-align': 'left' }"
                       [sortable]="true" [filterable]="true" [filter]="'text'">
      <ng-template kendoGridFilterCellTemplate let-filter>
        <dashboard-grid-text-filter [filter]="filter" placeholder="" [filterOperator]="'contains'" [field]="'experienceCodeDesc'">
        </dashboard-grid-text-filter>
      </ng-template>
    </kendo-grid-column>
    <kendo-grid-column *ngIf="hiddenColumns.indexOf('suppressionCheck') === -1" [field]="'suppressionCheck'" title="Suppression Check" [width]="100" [style]="{'text-align': 'left' }"
      [sortable]="true" [filterable]="true" [filter]="'boolean'">
      <!--Boolean Filter Cell -->
      <ng-template kendoGridFilterCellTemplate let-filter>
        <dashboard-grid-boolean-filter [filter]="filter" [field]="'suppressionCheck'"></dashboard-grid-boolean-filter>
      </ng-template>
      <!--End Boolean Filter Cell -->
      <!--Boolean Cell -->
      <ng-template kendoGridCellTemplate let-dataItem>
        <span *ngIf="dataItem !== undefined && dataItem['suppressionCheck'] === true" [ngClass]="{'fa fa-check-square': !gridSettings.showEnableDisable}" [ngStyle]="{'color': gridSettings.showEnableDisable? 'green': '#0069d9'}">  <span *ngIf="gridSettings.showEnableDisable" >&nbsp; Enabled</span> </span>
        <span *ngIf="dataItem !== undefined && dataItem['suppressionCheck'] === false" [ngClass]="{'far fa-square': !gridSettings.showEnableDisable}"  style="color: #c1cfcb;"> <span *ngIf="gridSettings.showEnableDisable" >&nbsp; Disabled</span> </span>
      </ng-template>
      <!--End Boolean Cell -->
    </kendo-grid-column>
    <kendo-grid-column *ngIf="hiddenColumns.indexOf('suppressionAuditSummary') === -1" [field]="'suppressionAuditSummary'" title="Suppression Audit Summary" [width]="150" [style]="{'text-align': 'left' }"
      [sortable]="true" [filterable]="true" [filter]="'text'">
      <ng-template kendoGridFilterCellTemplate let-filter>
        <dashboard-grid-text-filter [filter]="filter" placeholder="" [filterOperator]="'contains'" [field]="'suppressionAuditSummary'">
        </dashboard-grid-text-filter>
      </ng-template>
    </kendo-grid-column>
    <kendo-grid-column  *ngIf="hiddenColumns.indexOf('seasCheckPassed') === -1" [field]="'seasCheckPassed'" title="SEAS Check Passed" [width]="100" [style]="{'text-align': 'left' }"
                        [sortable]="true" [filterable]="true" [filter]="'boolean'">
      <!--Boolean Filter Cell -->
      <ng-template kendoGridFilterCellTemplate let-filter>
        <dashboard-grid-boolean-filter [filter]="filter" [field]="'seasCheckPassed'"></dashboard-grid-boolean-filter>
      </ng-template>
      <!--End Boolean Filter Cell -->
      <!--Boolean Cell -->
      <ng-template kendoGridCellTemplate let-dataItem>
        <span *ngIf="dataItem !== undefined && dataItem['seasCheckPassed'] === true" [ngClass]="{'fa fa-check-square': !gridSettings.showEnableDisable}" [ngStyle]="{'color': gridSettings.showEnableDisable? 'green': '#0069d9'}">  <span *ngIf="gridSettings.showEnableDisable" >&nbsp; Enabled</span> </span>
        <span *ngIf="dataItem !== undefined && dataItem['seasCheckPassed'] === false" [ngClass]="{'far fa-square': !gridSettings.showEnableDisable}"  style="color: #c1cfcb;"> <span *ngIf="gridSettings.showEnableDisable" >&nbsp; Disabled</span> </span>
      </ng-template>
      <!--End Boolean Cell -->
    </kendo-grid-column>
    <kendo-grid-column *ngIf="hiddenColumns.indexOf('seasCheckAuditSummary') === -1" [field]="'seasCheckAuditSummary'" title="SEAS Check Audit Summary" [width]="150" [style]="{'text-align': 'left' }"
                       [sortable]="true" [filterable]="true" [filter]="'text'">
      <ng-template kendoGridFilterCellTemplate let-filter>
        <dashboard-grid-text-filter [filter]="filter" placeholder="" [filterOperator]="'contains'" [field]="'seasCheckAuditSummary'">
        </dashboard-grid-text-filter>
      </ng-template>
    </kendo-grid-column>
    <kendo-grid-column  *ngIf="hiddenColumns.indexOf('torCheckPassed') === -1" [field]="'torCheckPassed'" title="TOR Check Passed" [width]="100" [style]="{'text-align': 'left' }"
                        [sortable]="true" [filterable]="true" [filter]="'boolean'">
      <!--Boolean Filter Cell -->
      <ng-template kendoGridFilterCellTemplate let-filter>
        <dashboard-grid-boolean-filter [filter]="filter" [field]="'torCheckPassed'"></dashboard-grid-boolean-filter>
      </ng-template>
      <!--End Boolean Filter Cell -->
      <!--Boolean Cell -->
      <ng-template kendoGridCellTemplate let-dataItem>
        <span *ngIf="dataItem !== undefined && dataItem['torCheckPassed'] === true" [ngClass]="{'fa fa-check-square': !gridSettings.showEnableDisable}" [ngStyle]="{'color': gridSettings.showEnableDisable? 'green': '#0069d9'}">  <span *ngIf="gridSettings.showEnableDisable" >&nbsp; Enabled</span> </span>
        <span *ngIf="dataItem !== undefined && dataItem['torCheckPassed'] === false" [ngClass]="{'far fa-square': !gridSettings.showEnableDisable}"  style="color: #c1cfcb;"> <span *ngIf="gridSettings.showEnableDisable" >&nbsp; Disabled</span> </span>
      </ng-template>
      <!--End Boolean Cell -->
    </kendo-grid-column>
    <kendo-grid-column *ngIf="hiddenColumns.indexOf('torCheckAuditSummary') === -1" [field]="'torCheckAuditSummary'" title="TOR Check Audit Summary" [width]="150" [style]="{'text-align': 'left' }"
                       [sortable]="true" [filterable]="true" [filter]="'text'">
      <ng-template kendoGridFilterCellTemplate let-filter>
        <dashboard-grid-text-filter [filter]="filter" placeholder="" [filterOperator]="'contains'" [field]="'torCheckAuditSummary'">
        </dashboard-grid-text-filter>
      </ng-template>
    </kendo-grid-column>
    <kendo-grid-column *ngIf="hiddenColumns.indexOf('isExcluded') === -1" [field]="'isExcluded'" title="Is Excluded" [width]="100" [style]="{'text-align': 'left' }"
      [sortable]="true" [filterable]="true" [filter]="'boolean'">
       <!--Boolean Filter Cell -->
       <ng-template kendoGridFilterCellTemplate let-filter>
        <dashboard-grid-boolean-filter [filter]="filter" [field]="'isExcluded'"></dashboard-grid-boolean-filter>
      </ng-template>
      <!--End Boolean Filter Cell -->
      <!--Boolean Cell -->
      <ng-template kendoGridCellTemplate let-dataItem>
        <span *ngIf="dataItem !== undefined && dataItem['isExcluded'] === true" [ngClass]="{'fa fa-check-square': !gridSettings.showEnableDisable}" [ngStyle]="{'color': gridSettings.showEnableDisable? 'green': '#0069d9'}">  <span *ngIf="gridSettings.showEnableDisable" >&nbsp; Enabled</span> </span>
        <span *ngIf="dataItem !== undefined && dataItem['isExcluded'] === false" [ngClass]="{'far fa-square': !gridSettings.showEnableDisable}"  style="color: #c1cfcb;"> <span *ngIf="gridSettings.showEnableDisable" >&nbsp; Disabled</span> </span>
      </ng-template>
      <!--End Boolean Cell -->
    </kendo-grid-column>
    <kendo-grid-column *ngIf="hiddenColumns.indexOf('exclusionAuditSummary') === -1" [field]="'exclusionAuditSummary'" title="Exclusion Audit Summary" [width]="150" [style]="{'text-align': 'left' }"
      [sortable]="true" [filterable]="true" [filter]="'text'">
      <ng-template kendoGridFilterCellTemplate let-filter>
        <dashboard-grid-text-filter [filter]="filter" placeholder="" [filterOperator]="'contains'" [field]="'exclusionAuditSummary'">
        </dashboard-grid-text-filter>
      </ng-template>
    </kendo-grid-column>
    <kendo-grid-column  *ngIf="hiddenColumns.indexOf('ticketValidationPassed') === -1" [field]="'ticketValidationPassed'" title="Ticket Validation Passed" [width]="100" [style]="{'text-align': 'left' }"
                        [sortable]="true" [filterable]="true" [filter]="'boolean'">
      <!--Boolean Filter Cell -->
      <ng-template kendoGridFilterCellTemplate let-filter>
        <dashboard-grid-boolean-filter [filter]="filter" [field]="'ticketValidationPassed'"></dashboard-grid-boolean-filter>
      </ng-template>
      <!--End Boolean Filter Cell -->
      <!--Boolean Cell -->
      <ng-template kendoGridCellTemplate let-dataItem>
        <span *ngIf="dataItem !== undefined && dataItem['ticketValidationPassed'] === true" [ngClass]="{'fa fa-check-square': !gridSettings.showEnableDisable}" [ngStyle]="{'color': gridSettings.showEnableDisable? 'green': '#0069d9'}">  <span *ngIf="gridSettings.showEnableDisable" >&nbsp; Enabled</span> </span>
        <span *ngIf="dataItem !== undefined && dataItem['ticketValidationPassed'] === false" [ngClass]="{'far fa-square': !gridSettings.showEnableDisable}"  style="color: #c1cfcb;"> <span *ngIf="gridSettings.showEnableDisable" >&nbsp; Disabled</span> </span>
      </ng-template>
      <!--End Boolean Cell -->
    </kendo-grid-column>
    <kendo-grid-column *ngIf="hiddenColumns.indexOf('ticketValidationAuditSummary') === -1" [field]="'ticketValidationAuditSummary'" title="Ticket Validation Audit Summary" [width]="150" [style]="{'text-align': 'left' }"
                       [sortable]="true" [filterable]="true" [filter]="'text'">
      <ng-template kendoGridFilterCellTemplate let-filter>
        <dashboard-grid-text-filter [filter]="filter" placeholder="" [filterOperator]="'contains'" [field]="'ticketValidationAuditSummary'">
        </dashboard-grid-text-filter>
      </ng-template>
    </kendo-grid-column>
    <kendo-grid-column  *ngIf="hiddenColumns.indexOf('hasServiceContractOverride') === -1" [field]="'hasServiceContractOverride'" title="Has Service Contract Override" [width]="100" [style]="{'text-align': 'left' }"
                        [sortable]="true" [filterable]="true" [filter]="'boolean'">
      <!--Boolean Filter Cell -->
      <ng-template kendoGridFilterCellTemplate let-filter>
        <dashboard-grid-boolean-filter [filter]="filter" [field]="'hasServiceContractOverride'"></dashboard-grid-boolean-filter>
      </ng-template>
      <!--End Boolean Filter Cell -->
      <!--Boolean Cell -->
      <ng-template kendoGridCellTemplate let-dataItem>
        <span *ngIf="dataItem !== undefined && dataItem['hasServiceContractOverride'] === true" [ngClass]="{'fa fa-check-square': !gridSettings.showEnableDisable}" [ngStyle]="{'color': gridSettings.showEnableDisable? 'green': '#0069d9'}">  <span *ngIf="gridSettings.showEnableDisable" >&nbsp; Enabled</span> </span>
        <span *ngIf="dataItem !== undefined && dataItem['hasServiceContractOverride'] === false" [ngClass]="{'far fa-square': !gridSettings.showEnableDisable}"  style="color: #c1cfcb;"> <span *ngIf="gridSettings.showEnableDisable" >&nbsp; Disabled</span> </span>
      </ng-template>
      <!--End Boolean Cell -->
    </kendo-grid-column>
    <kendo-grid-column *ngIf="hiddenColumns.indexOf('serviceContractOverrideReason') === -1" [field]="'serviceContractOverrideReason'" title="Service Contract Override Reason" [width]="150" [style]="{'text-align': 'left' }"
                       [sortable]="true" [filterable]="true" [filter]="'text'">
      <ng-template kendoGridFilterCellTemplate let-filter>
        <dashboard-grid-text-filter [filter]="filter" placeholder="" [filterOperator]="'contains'" [field]="'serviceContractOverrideReason'">
        </dashboard-grid-text-filter>
      </ng-template>
    </kendo-grid-column>
    <kendo-grid-column  *ngIf="hiddenColumns.indexOf('hasServiceContract') === -1" [field]="'hasServiceContract'" title="Has Service Contract" [width]="100" [style]="{'text-align': 'left' }"
      [sortable]="true" [filterable]="true" [filter]="'boolean'">
       <!--Boolean Filter Cell -->
       <ng-template kendoGridFilterCellTemplate let-filter>
        <dashboard-grid-boolean-filter [filter]="filter" [field]="'hasServiceContract'"></dashboard-grid-boolean-filter>
      </ng-template>
      <!--End Boolean Filter Cell -->
      <!--Boolean Cell -->
      <ng-template kendoGridCellTemplate let-dataItem>
        <span *ngIf="dataItem !== undefined && dataItem['hasServiceContract'] === true" [ngClass]="{'fa fa-check-square': !gridSettings.showEnableDisable}" [ngStyle]="{'color': gridSettings.showEnableDisable? 'green': '#0069d9'}">  <span *ngIf="gridSettings.showEnableDisable" >&nbsp; Enabled</span> </span>
        <span *ngIf="dataItem !== undefined && dataItem['hasServiceContract'] === false" [ngClass]="{'far fa-square': !gridSettings.showEnableDisable}"  style="color: #c1cfcb;"> <span *ngIf="gridSettings.showEnableDisable" >&nbsp; Disabled</span> </span>
      </ng-template>
      <!--End Boolean Cell -->
    </kendo-grid-column>
    <kendo-grid-column *ngIf="hiddenColumns.indexOf('serviceContractAuditSummary') === -1" [field]="'serviceContractAuditSummary'" title="Service Contract Audit Summary" [width]="150" [style]="{'text-align': 'left' }"
      [sortable]="true" [filterable]="true" [filter]="'text'">
      <ng-template kendoGridFilterCellTemplate let-filter>
        <dashboard-grid-text-filter [filter]="filter" placeholder="" [filterOperator]="'contains'" [field]="'serviceContractAuditSummary'">
        </dashboard-grid-text-filter>
      </ng-template>
    </kendo-grid-column>
    <kendo-grid-column *ngIf="hiddenColumns.indexOf('overallNotificationEnabled') === -1" [field]="'overallNotificationEnabled'" title="Overall Notification Enabled" [width]="100" [style]="{'text-align': 'left' }"
      [sortable]="true" [filterable]="true" [filter]="'boolean'">
       <!--Boolean Filter Cell -->
       <ng-template kendoGridFilterCellTemplate let-filter>
        <dashboard-grid-boolean-filter [filter]="filter" [field]="'overallNotificationEnabled'"></dashboard-grid-boolean-filter>
      </ng-template>
      <!--End Boolean Filter Cell -->
      <!--Boolean Cell -->
      <ng-template kendoGridCellTemplate let-dataItem>
        <span *ngIf="dataItem !== undefined && dataItem['overallNotificationEnabled'] === true" [ngClass]="{'fa fa-check-square': !gridSettings.showEnableDisable}" [ngStyle]="{'color': gridSettings.showEnableDisable? 'green': '#0069d9'}">  <span *ngIf="gridSettings.showEnableDisable" >&nbsp; Enabled</span> </span>
        <span *ngIf="dataItem !== undefined && dataItem['overallNotificationEnabled'] === false" [ngClass]="{'far fa-square': !gridSettings.showEnableDisable}"  style="color: #c1cfcb;"> <span *ngIf="gridSettings.showEnableDisable" >&nbsp; Disabled</span> </span>
      </ng-template>
      <!--End Boolean Cell -->
    </kendo-grid-column>
    <kendo-grid-column *ngIf="hiddenColumns.indexOf('notificationAuditSummary') === -1" [field]="'notificationAuditSummary'" title="Notification Audit Summary" [width]="150" [style]="{'text-align': 'left' }"
                       [sortable]="true" [filterable]="true" [filter]="'text'">
      <ng-template kendoGridFilterCellTemplate let-filter>
        <dashboard-grid-text-filter [filter]="filter" placeholder="" [filterOperator]="'contains'" [field]="'notificationAuditSummary'">
        </dashboard-grid-text-filter>
      </ng-template>
    </kendo-grid-column>
    <kendo-grid-column *ngIf="hiddenColumns.indexOf('ticketNotificationEnabled') === -1" [field]="'ticketNotificationEnabled'" title="Ticket Notification Enabled" [width]="100" [style]="{'text-align': 'left' }"
                       [sortable]="true" [filterable]="true" [filter]="'boolean'">
      <!--Boolean Filter Cell -->
      <ng-template kendoGridFilterCellTemplate let-filter>
        <dashboard-grid-boolean-filter [filter]="filter" [field]="'ticketNotificationEnabled'"></dashboard-grid-boolean-filter>
      </ng-template>
      <!--End Boolean Filter Cell -->
      <!--Boolean Cell -->
      <ng-template kendoGridCellTemplate let-dataItem>
        <span *ngIf="dataItem !== undefined && dataItem['ticketNotificationEnabled'] === true" [ngClass]="{'fa fa-check-square': !gridSettings.showEnableDisable}" [ngStyle]="{'color': gridSettings.showEnableDisable? 'green': '#0069d9'}">  <span *ngIf="gridSettings.showEnableDisable" >&nbsp; Enabled</span> </span>
        <span *ngIf="dataItem !== undefined && dataItem['ticketNotificationEnabled'] === false" [ngClass]="{'far fa-square': !gridSettings.showEnableDisable}"  style="color: #c1cfcb;"> <span *ngIf="gridSettings.showEnableDisable" >&nbsp; Disabled</span> </span>
      </ng-template>
      <!--End Boolean Cell -->
    </kendo-grid-column>
    <kendo-grid-column *ngIf="hiddenColumns.indexOf('ticketCreated') === -1" [field]="'ticketCreated'" title="Ticket Created" [width]="100" [style]="{'text-align': 'left' }"
                       [sortable]="true" [filterable]="true" [filter]="'boolean'">
      <!--Boolean Filter Cell -->
      <ng-template kendoGridFilterCellTemplate let-filter>
        <dashboard-grid-boolean-filter [filter]="filter" [field]="'ticketCreated'"></dashboard-grid-boolean-filter>
      </ng-template>
      <!--End Boolean Filter Cell -->
      <!--Boolean Cell -->
      <ng-template kendoGridCellTemplate let-dataItem>
        <span *ngIf="dataItem !== undefined && dataItem['ticketCreated'] === true" [ngClass]="{'fa fa-check-square': !gridSettings.showEnableDisable}" [ngStyle]="{'color': gridSettings.showEnableDisable? 'green': '#0069d9'}">  <span *ngIf="gridSettings.showEnableDisable" >&nbsp; Enabled</span> </span>
        <span *ngIf="dataItem !== undefined && dataItem['ticketCreated'] === false" [ngClass]="{'far fa-square': !gridSettings.showEnableDisable}"  style="color: #c1cfcb;"> <span *ngIf="gridSettings.showEnableDisable" >&nbsp; Disabled</span> </span>
      </ng-template>
      <!--End Boolean Cell -->
    </kendo-grid-column>
    <kendo-grid-column *ngIf="hiddenColumns.indexOf('ticketNumber') === -1" [field]="'ticketNumber'" title="Ticket Number" [width]="150" [style]="{'text-align': 'left' }"
                       [sortable]="true" [filterable]="true" [filter]="'text'">
      <ng-template kendoGridFilterCellTemplate let-filter>
        <dashboard-grid-text-filter [filter]="filter" placeholder="" [filterOperator]="'contains'" [field]="'ticketNumber'">
        </dashboard-grid-text-filter>
      </ng-template>
    </kendo-grid-column>
    <kendo-grid-column *ngIf="hiddenColumns.indexOf('ticketOwner') === -1" [field]="'ticketOwner'" title="Ticket Owner" [width]="150" [style]="{'text-align': 'left' }"
                       [sortable]="true" [filterable]="true" [filter]="'text'">
      <ng-template kendoGridFilterCellTemplate let-filter>
        <dashboard-grid-text-filter [filter]="filter" placeholder="" [filterOperator]="'contains'" [field]="'ticketOwner'">
        </dashboard-grid-text-filter>
      </ng-template>
    </kendo-grid-column>
    <kendo-grid-column *ngIf="hiddenColumns.indexOf('ticketNotificationDate') === -1" [field]="'ticketNotificationDate'" title="Ticket Notification Date" [width]="180" [style]="{'text-align': 'left' }"
                       [sortable]="true" [filterable]="true" [filter]="'date'" [format]="'{0:yyyy-MM-dd HH:mm}'">
                       <ng-template kendoGridCellTemplate let-dataItem>
                        {{ convertToUserTimeZone(dataItem.ticketNotificationDate) | date:'yyyy-MM-dd HH:mm' }}
                      </ng-template>
      <ng-template kendoGridFilterCellTemplate let-filter let-column="column">
        <kendo-grid-date-filter-cell
          [showOperators]="true"
          [column]="column"
          [filter]="filter"
          format="yyyy-MM-dd HH:mm"
          [placeholder]="'Select Date'" >
          <kendo-filter-eq-operator [text]="' =='"></kendo-filter-eq-operator>
          <kendo-filter-neq-operator [text]="' !='"></kendo-filter-neq-operator>
          <kendo-filter-gte-operator [text]="' >='"></kendo-filter-gte-operator>
          <kendo-filter-after-operator [text]="' >'"></kendo-filter-after-operator>
          <kendo-filter-lte-operator [text]="' <='"></kendo-filter-lte-operator>
          <kendo-filter-before-operator [text]="' <'"></kendo-filter-before-operator>
          <kendo-filter-isnull-operator [text]="' Empty'"></kendo-filter-isnull-operator>
          <kendo-filter-isnotnull-operator [text]="' Non Empty'"></kendo-filter-isnotnull-operator>
        </kendo-grid-date-filter-cell>
      </ng-template>
    </kendo-grid-column>
    <kendo-grid-column *ngIf="hiddenColumns.indexOf('ticketDueDate') === -1" [field]="'ticketDueDate'" title="Ticket Due Date" [width]="180" [style]="{'text-align': 'left' }"
                       [sortable]="true" [filterable]="true" [filter]="'date'" [format]="'{0:yyyy-MM-dd HH:mm}'">
                       <ng-template kendoGridCellTemplate let-dataItem>
                        {{ convertToUserTimeZone(dataItem.ticketDueDate) | date:'yyyy-MM-dd HH:mm' }}
                      </ng-template>
      <ng-template kendoGridFilterCellTemplate let-filter let-column="column">
        <kendo-grid-date-filter-cell
          [showOperators]="true"
          [column]="column"
          [filter]="filter"
          format="yyyy-MM-dd HH:mm"
          [placeholder]="'Select Date'">
          <kendo-filter-eq-operator [text]="' =='"></kendo-filter-eq-operator>
          <kendo-filter-neq-operator [text]="' !='"></kendo-filter-neq-operator>
          <kendo-filter-gte-operator [text]="' >='"></kendo-filter-gte-operator>
          <kendo-filter-after-operator [text]="' >'"></kendo-filter-after-operator>
          <kendo-filter-lte-operator [text]="' <='"></kendo-filter-lte-operator>
          <kendo-filter-before-operator [text]="' <'"></kendo-filter-before-operator>
          <kendo-filter-isnull-operator [text]="' Empty'"></kendo-filter-isnull-operator>
          <kendo-filter-isnotnull-operator [text]="' Non Empty'"></kendo-filter-isnotnull-operator>
        </kendo-grid-date-filter-cell>
      </ng-template>
    </kendo-grid-column>
    <kendo-grid-column *ngIf="hiddenColumns.indexOf('ticketNotificationException') === -1" [field]="'ticketNotificationException'" title="Ticket Notification Exception" [width]="150" [style]="{'text-align': 'left' }"
                       [sortable]="true" [filterable]="true" [filter]="'text'">
      <ng-template kendoGridCellTemplate let-dataItem>
        <div class="limited-text">{{ dataItem.ticketNotificationException }}</div>
      </ng-template>
      <ng-template kendoGridFilterCellTemplate let-filter>
        <dashboard-grid-text-filter [filter]="filter" placeholder="" [filterOperator]="'contains'" [field]="'ticketNotificationException'">
        </dashboard-grid-text-filter>
      </ng-template>
    </kendo-grid-column>
    <kendo-grid-column *ngIf="hiddenColumns.indexOf('oneViewNotificationEnabled') === -1" [field]="'oneViewNotificationEnabled'" title="ONeview Notification Enabled" [width]="100" [style]="{'text-align': 'left' }"
                       [sortable]="true" [filterable]="true" [filter]="'boolean'">
      <!--Boolean Filter Cell -->
      <ng-template kendoGridFilterCellTemplate let-filter>
        <dashboard-grid-boolean-filter [filter]="filter" [field]="'oneViewNotificationEnabled'"></dashboard-grid-boolean-filter>
      </ng-template>
      <!--End Boolean Filter Cell -->
      <!--Boolean Cell -->
      <ng-template kendoGridCellTemplate let-dataItem>
        <span *ngIf="dataItem !== undefined && dataItem['oneViewNotificationEnabled'] === true" [ngClass]="{'fa fa-check-square': !gridSettings.showEnableDisable}" [ngStyle]="{'color': gridSettings.showEnableDisable? 'green': '#0069d9'}">  <span *ngIf="gridSettings.showEnableDisable" >&nbsp; Enabled</span> </span>
        <span *ngIf="dataItem !== undefined && dataItem['oneViewNotificationEnabled'] === false" [ngClass]="{'far fa-square': !gridSettings.showEnableDisable}"  style="color: #c1cfcb;"> <span *ngIf="gridSettings.showEnableDisable" >&nbsp; Disabled</span> </span>
      </ng-template>
      <!--End Boolean Cell -->
    </kendo-grid-column>
    <kendo-grid-column *ngIf="hiddenColumns.indexOf('oneViewAlertsSent') === -1" [field]="'oneViewAlertsSent'" title="ONeview Alert(s) Sent" [width]="100" [style]="{'text-align': 'left' }"
                       [sortable]="true" [filterable]="true" [filter]="'boolean'">
      <!--Boolean Filter Cell -->
      <ng-template kendoGridFilterCellTemplate let-filter>
        <dashboard-grid-boolean-filter [filter]="filter" [field]="'oneViewAlertsSent'"></dashboard-grid-boolean-filter>
      </ng-template>
      <!--End Boolean Filter Cell -->
      <!--Boolean Cell -->
      <ng-template kendoGridCellTemplate let-dataItem>
        <span *ngIf="dataItem !== undefined && dataItem['oneViewAlertsSent'] === true" [ngClass]="{'fa fa-check-square': !gridSettings.showEnableDisable}" [ngStyle]="{'color': gridSettings.showEnableDisable? 'green': '#0069d9'}">  <span *ngIf="gridSettings.showEnableDisable" >&nbsp; Enabled</span> </span>
        <span *ngIf="dataItem !== undefined && dataItem['oneViewAlertsSent'] === false" [ngClass]="{'far fa-square': !gridSettings.showEnableDisable}"  style="color: #c1cfcb;"> <span *ngIf="gridSettings.showEnableDisable" >&nbsp; Disabled</span> </span>
      </ng-template>
      <!--End Boolean Cell -->
    </kendo-grid-column>
    <kendo-grid-column *ngIf="hiddenColumns.indexOf('oneViewNotificationRecipients') === -1" [field]="'oneViewNotificationRecipients'" title="ONeview Notification Recipients" [width]="150" [style]="{'text-align': 'left' }"
                       [sortable]="true" [filterable]="true" [filter]="'text'">
      <ng-template kendoGridFilterCellTemplate let-filter>
        <dashboard-grid-text-filter [filter]="filter" placeholder="" [filterOperator]="'contains'" [field]="'oneViewNotificationRecipients'">
        </dashboard-grid-text-filter>
      </ng-template>
    </kendo-grid-column>
    <kendo-grid-column *ngIf="hiddenColumns.indexOf('oneViewNotificationDate') === -1" [field]="'oneViewNotificationDate'" title="ONeview Notification Date" [width]="180" [style]="{'text-align': 'left' }"
                       [sortable]="true" [filterable]="true" [filter]="'date'" [format]="'{0:yyyy-MM-dd HH:mm}'">
                       <ng-template kendoGridCellTemplate let-dataItem>
                        {{ convertToUserTimeZone(dataItem.oneViewNotificationDate) | date:'yyyy-MM-dd HH:mm' }}
                      </ng-template>
      <ng-template kendoGridFilterCellTemplate let-filter let-column="column">
        <kendo-grid-date-filter-cell
          [showOperators]="true"
          [column]="column"
          [filter]="filter"
          format="yyyy-MM-dd HH:mm"
          [placeholder]="'Select Date'">
          <kendo-filter-eq-operator [text]="' =='"></kendo-filter-eq-operator>
          <kendo-filter-neq-operator [text]="' !='"></kendo-filter-neq-operator>
          <kendo-filter-gte-operator [text]="' >='"></kendo-filter-gte-operator>
          <kendo-filter-after-operator [text]="' >'"></kendo-filter-after-operator>
          <kendo-filter-lte-operator [text]="' <='"></kendo-filter-lte-operator>
          <kendo-filter-before-operator [text]="' <'"></kendo-filter-before-operator>
          <kendo-filter-isnull-operator [text]="' Empty'"></kendo-filter-isnull-operator>
          <kendo-filter-isnotnull-operator [text]="' Non Empty'"></kendo-filter-isnotnull-operator>
        </kendo-grid-date-filter-cell>
      </ng-template>
    </kendo-grid-column>
    <kendo-grid-column *ngIf="hiddenColumns.indexOf('oneViewNotificationException') === -1" [field]="'oneViewNotificationException'" title="ONeview Notification Exception" [width]="150" [style]="{'text-align': 'left' }"
                       [sortable]="true" [filterable]="true" [filter]="'text'">
      <ng-template kendoGridCellTemplate let-dataItem>
        <div class="limited-text">{{ dataItem.oneViewNotificationException }}</div>
      </ng-template>
      <ng-template kendoGridFilterCellTemplate let-filter>
        <dashboard-grid-text-filter [filter]="filter" placeholder="" [filterOperator]="'contains'" [field]="'oneViewNotificationException'">
        </dashboard-grid-text-filter>
      </ng-template>
    </kendo-grid-column>
    <kendo-grid-column *ngIf="hiddenColumns.indexOf('emailNotificationEnabled') === -1" [field]="'emailNotificationEnabled'" title="Email Notification Enabled" [width]="100" [style]="{'text-align': 'left' }"
      [sortable]="true" [filterable]="true" [filter]="'boolean'">
       <!--Boolean Filter Cell -->
       <ng-template kendoGridFilterCellTemplate let-filter>
        <dashboard-grid-boolean-filter [filter]="filter" [field]="'emailNotificationEnabled'"></dashboard-grid-boolean-filter>
      </ng-template>
      <!--End Boolean Filter Cell -->
      <!--Boolean Cell -->
      <ng-template kendoGridCellTemplate let-dataItem>
        <span *ngIf="dataItem !== undefined && dataItem['emailNotificationEnabled'] === true" [ngClass]="{'fa fa-check-square': !gridSettings.showEnableDisable}" [ngStyle]="{'color': gridSettings.showEnableDisable? 'green': '#0069d9'}">  <span *ngIf="gridSettings.showEnableDisable" >&nbsp; Enabled</span> </span>
        <span *ngIf="dataItem !== undefined && dataItem['emailNotificationEnabled'] === false" [ngClass]="{'far fa-square': !gridSettings.showEnableDisable}"  style="color: #c1cfcb;"> <span *ngIf="gridSettings.showEnableDisable" >&nbsp; Disabled</span> </span>
      </ng-template>
      <!--End Boolean Cell -->
    </kendo-grid-column>
    <kendo-grid-column *ngIf="hiddenColumns.indexOf('emailAlertsSent') === -1" [field]="'emailAlertsSent'" title="Email Alert(s) Sent" [width]="100" [style]="{'text-align': 'left' }"
                       [sortable]="true" [filterable]="true" [filter]="'boolean'">
      <!--Boolean Filter Cell -->
      <ng-template kendoGridFilterCellTemplate let-filter>
        <dashboard-grid-boolean-filter [filter]="filter" [field]="'emailAlertsSent'"></dashboard-grid-boolean-filter>
      </ng-template>
      <!--End Boolean Filter Cell -->
      <!--Boolean Cell -->
      <ng-template kendoGridCellTemplate let-dataItem>
        <span *ngIf="dataItem !== undefined && dataItem['emailAlertsSent'] === true" [ngClass]="{'fa fa-check-square': !gridSettings.showEnableDisable}" [ngStyle]="{'color': gridSettings.showEnableDisable? 'green': '#0069d9'}">  <span *ngIf="gridSettings.showEnableDisable" >&nbsp; Enabled</span> </span>
        <span *ngIf="dataItem !== undefined && dataItem['emailAlertsSent'] === false" [ngClass]="{'far fa-square': !gridSettings.showEnableDisable}"  style="color: #c1cfcb;"> <span *ngIf="gridSettings.showEnableDisable" >&nbsp; Disabled</span> </span>
      </ng-template>
      <!--End Boolean Cell -->
    </kendo-grid-column>
    <kendo-grid-column *ngIf="hiddenColumns.indexOf('emailNotificationRecipients') === -1" [field]="'emailNotificationRecipients'" title="Email Notification Recipients" [width]="150" [style]="{'text-align': 'left' }"
      [sortable]="true" [filterable]="true" [filter]="'text'">
      <ng-template kendoGridFilterCellTemplate let-filter>
        <dashboard-grid-text-filter [filter]="filter" placeholder="" [filterOperator]="'contains'" [field]="'emailNotificationRecipients'">
        </dashboard-grid-text-filter>
      </ng-template>
    </kendo-grid-column>
    <kendo-grid-column *ngIf="hiddenColumns.indexOf('emailNotificationDate') === -1" [field]="'emailNotificationDate'" title="Email Notification Date" [width]="180" [style]="{'text-align': 'left' }"
          [sortable]="true" [filterable]="true" [filter]="'date'" [format]="'{0:yyyy-MM-dd HH:mm}'">
          <ng-template kendoGridCellTemplate let-dataItem>
            {{ convertToUserTimeZone(dataItem.emailNotificationDate) | date:'yyyy-MM-dd HH:mm' }}
          </ng-template>
      <ng-template kendoGridFilterCellTemplate let-filter let-column="column">
        <kendo-grid-date-filter-cell
          [showOperators]="true"
          [column]="column"
          [filter]="filter"
          format="yyyy-MM-dd HH:mm"
          [placeholder]="'Select Date'">
            <kendo-filter-eq-operator [text]="' =='"></kendo-filter-eq-operator>
            <kendo-filter-neq-operator [text]="' !='"></kendo-filter-neq-operator>
            <kendo-filter-gte-operator [text]="' >='"></kendo-filter-gte-operator>
            <kendo-filter-after-operator [text]="' >'"></kendo-filter-after-operator>
            <kendo-filter-lte-operator [text]="' <='"></kendo-filter-lte-operator>
            <kendo-filter-before-operator [text]="' <'"></kendo-filter-before-operator>
            <kendo-filter-isnull-operator [text]="' Empty'"></kendo-filter-isnull-operator>
            <kendo-filter-isnotnull-operator [text]="' Non Empty'"></kendo-filter-isnotnull-operator>
        </kendo-grid-date-filter-cell>
      </ng-template>
    </kendo-grid-column>
    <kendo-grid-column *ngIf="hiddenColumns.indexOf('emailNotificationException') === -1" [field]="'emailNotificationException'" title="Email Notification Exception" [width]="150" [style]="{'text-align': 'left' }"
                       [sortable]="true" [filterable]="true" [filter]="'text'">
      <ng-template kendoGridCellTemplate let-dataItem>
        <div class="limited-text">{{ dataItem.emailNotificationException }}</div>
      </ng-template>
      <ng-template kendoGridFilterCellTemplate let-filter>
        <dashboard-grid-text-filter [filter]="filter" placeholder="" [filterOperator]="'contains'" [field]="'emailNotificationException'">
        </dashboard-grid-text-filter>
      </ng-template>
    </kendo-grid-column>
    <kendo-grid-column *ngIf="hiddenColumns.indexOf('processId') === -1" [field]="'processId'" title="Process Id" [width]="150" [style]="{'text-align': 'left' }"
                       [sortable]="true" [filterable]="true" [filter]="'text'">
      <ng-template kendoGridFilterCellTemplate let-filter>
        <dashboard-grid-text-filter [filter]="filter" placeholder="" [filterOperator]="'contains'" [field]="'processId'">
        </dashboard-grid-text-filter>
      </ng-template>
    </kendo-grid-column>
    <!--Default Kendo Excel Export-->
    <kendo-grid-excel [fileName]="gridSettings.exportFileName + '.xlsx'" [filterable]="true" [fetchData]="saveExcel">
      <div *ngFor="let column of gridSettings?.columnSettings">
          <kendo-excelexport-column [field]="column.field" [title]="column.title"></kendo-excelexport-column>
      </div>
    </kendo-grid-excel>
    <!--End Default Excel Export-->
  </kendo-grid>
</div>



